import * as React from "react";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import { useSiteCommands } from "../../../queries/useSiteCommands.ts";

import {
  ClickAwayListener,
  Typography,
  Popover,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Divider,
  Tooltip,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import styled from "@emotion/styled";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  H6HeadlineSmall,
  BodyLarge,
  BodySmall,
} from "../../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../../components/StyledComponents/Buttons/AuradineButtons.js";
import { useForm } from "react-hook-form";
import useMinerPageContext from "../../../context/useMinerPageContext.js";
import useSiteAndGroupTreeContext from "../../../context/useSiteAndGroupTreeContext.js";
import useAppContextProvider from "../../../../AppContext/useAppContextProvider.js";
import MinerConfigurationDialog from "../../ConfigurationModal/ConfigurationModal.js";
import {
  CustomPowerForm,
  CustomRetuneForm,
  CustomTHSForm,
  DeleteMinersDialog,
  TransferMinerForm,
  FactoryResetDialog,
  ResetCurtailSchedulesDialog,
  RestartDialog,
  EcoDialog,
  TurboDialog,
  ReImageDialog,
} from "../../CustomizationModal/CustomizationModal.js";
import UpgradeMinersDialog from "../../UpgradeMinersDialog/UpgradeMinersDialog.js";
import { useQuery } from "@tanstack/react-query";
import * as api from "../../../../api/api.js";
import { GetUserUseQuery } from "../../../../api/api.js";
import { useExportCSV } from "../../../queries/useExportCSV.ts";
import { SecondaryButton } from "../../../../components/StyledComponents/Buttons/AuradineButtons.js";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";

const StyledPopoverContent = styled(Box)(({ colors }) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: "1rem",
  backgroundColor: colors?.background?.popover,
  boxShadow: "0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.3)",
}));

const StyledPopover = styled(Popover,)(({ colors }) => ({
  "& .MuiPaper-root": {
    borderRadius: "1rem",
    backgroundColor: colors?.background?.popover,
  },
}));

const StyledHeaderAndFooterBox = styled(Box)`
  padding: 1.5rem;
`;

const MoreOptionsCard = (props) => {
  const {
    open,
    handleClose,
    anchorRef,
    downloadCSV,
    setTableKey,
    refetch,
    role,
  } = props;
  const {
    mutate: sendMinerCommands,
    mutate: sendSiteCommands,
  } = useSiteCommands();
  const {
    selectedSerials,
    setMinerConfigurationModalOpen,
    setWhichMinerConfigurationForm,
    setCustomizationModalOpen,
    setCustomPowerModalOpen,
    setTransferModalOpen,
    setRetuneModalOpen,
    setUpgradeModalOpen,
    setMinerDeletionModalOpen,
    setResetCurtailSchedulesModalOpen,
    setFactoryResetModalOpen,
    setReImageModalOpen,
    groupFilters,
    setRestartModalOpen,
    setEcoModalOpen,
    setTurboModalOpen,
    setStepperOpen,
    setJobId,
    customizationModalOpen,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const navigate = useHistory();
  const { colors } = useTheme();
  const { handleSubmit, control, watch } = useForm({
    defaultValues: {
      switchValue1: false,
      switchValue2: false,
      switchValue3: false,
      // Default value for the switch
    },
  });

  const { mutate: transferCSV } = useExportCSV();

  const menuOptions = [
    {
      title: "Upgrade Miners",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          system_update
        </span>
      ),
      onClick: () => {
        setUpgradeModalOpen(true);
        handleClose();
      },
      needDivider: false,
    },
    {
      title: "Stop Rolling Upgrade",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          delete
        </span>
      ),
      onClick: () => {
        sendSiteCommands(
          {
            siteName: siteSelectedName,
            serials: selectedSerials,
            commands: {
              command: "rolling-firmware-upgrade",
              operation: "cancel",
            },
            filter: {
              ...groupFilters,
              ...(groupSelectedName !== ""
                ? { dgname: groupSelectedName }
                : {}),
              ...(siteSelectedName !== ""
                ? { siteName: siteSelectedName }
                : {}),
            },
          },
          {
            onSuccess: async (response) => {
              if (response.status === "ok") {
                await refetch();
                setTableKey((prev) => prev + 1);
                if (response?.jobid) {
                  // navigate.push(
                  //   `/jobDetails?jobID=${response?.jobid}`
                  // );
                  setStepperOpen(true);
                  setJobId(response?.jobid);
                }
              } else {
                setToastMessage(
                  `Status of delete rolling upgrade command: ${response.msg}`
                );
                setToastOpen(true);
              }
            },
            onError: (error) => {
              setToastMessage(
                `Error sending delete rolling upgrade command: ${error}`
              );
              setToastOpen(true);
            },
          }
        );

        handleClose();
      },
      needDivider: false,
    },
    {
      title: "Restart miners",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          restart_alt
        </span>
      ),
      onClick: () => {
        setRestartModalOpen(true);
        handleClose();
      },
      needDivider: true,
    },
    {
      title: "Eco",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          eco
        </span>
      ),
      onClick: () => {
        setEcoModalOpen(true);
        handleClose();
      },
      needDivider: false,
    },
    {
      title: "Turbo",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          rocket_launch
        </span>
      ),
      onClick: () => {
        setTurboModalOpen(true);
        handleClose();
      },
      needDivider: false,
    },
    {
      title: "Custom THs",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          tornado
        </span>
      ),
      onClick: () => {
        setCustomizationModalOpen(true);
        handleClose();
      },
    },
    {
      title: "Custom Power",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          bolt
        </span>
      ),
      onClick: () => {
        setCustomPowerModalOpen(true);
        handleClose();
      },
    },

    {
      title: "Retune",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          reset_settings
        </span>
      ),
      onClick: () => {
        setRetuneModalOpen(true);
        handleClose();
      },
      needDivider: true,
    },
    {
      title: "Standby Mode",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          sleep
        </span>
      ),
      onClick: () => {
        setMinerConfigurationModalOpen(true);
        setWhichMinerConfigurationForm("standbyMode");
        handleClose();
      },
    },
    {
      title: "Persist Standby Mode",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          autostop
        </span>
      ),
      onClick: () => {
        setMinerConfigurationModalOpen(true);
        setWhichMinerConfigurationForm(
          "persistStandbyMode"
        );
        handleClose();
      },
    },
    {
      title: "Optimize fan speed",
      endIcon: () => (
          <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          mode_fan
        </span>
      ),
      onClick: () => {
        setMinerConfigurationModalOpen(true);
        setWhichMinerConfigurationForm("fanInStandby");
        handleClose();
      },
    },
    {
      title: "Enhanced ECO",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          energy_program_saving
        </span>
      ),
      onClick: () => {
        setMinerConfigurationModalOpen(true);
        setWhichMinerConfigurationForm("optimizeEco");
        handleClose();
      },
    },
    {
      title: "Mine W/O Internet",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          currency_bitcoin
        </span>
      ),
      onClick: () => {
        setMinerConfigurationModalOpen(true);
        setWhichMinerConfigurationForm(
          "mineWithoutInternet"
        );
        handleClose();
      },
    },
    {
      title: "Leak Detect Mode",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          water_drop
        </span>
      ),
      onClick: () => {
        setMinerConfigurationModalOpen(true);
        setWhichMinerConfigurationForm("leakDetected");
        handleClose();
      },
      needDivider: true,
    },
    {
      title: "Flash LED",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          flare
        </span>
      ),
      onClick: () => {
        setMinerConfigurationModalOpen(true);
        setWhichMinerConfigurationForm("flashLED");
        handleClose();
      },
    },
    {
      title: "Download CSV",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          csv
        </span>
      ),
      onClick: () => {
        // if (selectedSerials.length !== 0) {
        //   console.log(
        //     "Downloading CSV for selected miners",
        //     selectedSerials
        //   );

        //   downloadCSV();
        // } else {
        transferCSV(
          {
            siteName: siteSelectedName,
            dglist: groupSelectedName
              ? [groupSelectedName]
              : [],
          },
          {
            onSuccess: async (response) => {
              if (response.status === "ok") {
                setToastMessage(
                  "CSV file has been downloaded successfully"
                );
                setToastOpen(true);
                console.log(
                  "CSV file downloaded successfully"
                );
              } else {
                setToastMessage(
                  `Error downloading CSV file: ${response.msg}`
                );
                setToastOpen(true);
              }
            },
            onError: (error) => {
              setToastMessage(
                `Error downloading CSV file: ${error}`
              );
              setToastOpen(true);
            },
          }
        );
        handleClose();
      },
      needDivider: true,
      // },
      // disabled: selectedSerials.length === 0,
    },
    {
      title: "Transfer Miners",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          move_up
        </span>
      ),
      onClick: () => {
        setTransferModalOpen(true);
        handleClose();
      },
      disabled:
        !(
          siteSelectedName !== "" &&
          groupSelectedName !== ""
        ) ||
        selectedSerials.length === 0 ||
        role !== "superadmin",
    },
    {
      title: "Delete Miners",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          delete_forever
        </span>
      ),
      onClick: () => {
        setMinerDeletionModalOpen(true);
        handleClose();
      },
      disabled:
        !(
          siteSelectedName !== "" &&
          groupSelectedName !== ""
        ) ||
        selectedSerials.length === 0 ||
        role !== "superadmin",
      needDivider: true,
    },
    {
      title: "Reset Curtail Schedules",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          event_repeat
        </span>
      ),
      onClick: () => {
        setResetCurtailSchedulesModalOpen(true);
        handleClose();
      },
      needDivider: false,
    },
    {
      title: "Factory Reset",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          reset_wrench
        </span>
      ),
      onClick: () => {
        setFactoryResetModalOpen(true);
        handleClose();
      },
      needDivider: false,
    },
    {
      title: "Recover Boot Partition",
      endIcon: () => (
        <span className="material-symbols-outlined" style={{ color: colors?.text?.muted }}>
          healing
        </span>
      ),
      onClick: () => {
        setReImageModalOpen(true);
        handleClose();
      },
      needDivider: false,
    },
  ];

  return (
    <>
      <StyledPopover
        colors={colors}
        sx={{
          zIndex: 9999,
          borderRadius: "1rem",
        }}
        open={open}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <StyledPopoverContent
            colors={colors}
            display={"flex"}
            flexGrow={1}
          >
            <StyledHeaderAndFooterBox
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-start"}
            >
              <H6HeadlineSmall>
                Additional actions
              </H6HeadlineSmall>
            </StyledHeaderAndFooterBox>

            <Box
              display={"flex"}
              flexDirection={"column"}
              pb={"1rem"}
            >
              <Box
                display={"flex"}
                maxHeight={"25rem"}
                overflow={"auto"}
                flexDirection={"column"}
                sx={{
                  scrollbarWidth: "thin",
                  scrollBehavior: "smooth ",
                  willChange: "transform",
                }}
              >
                {menuOptions.map((option, index) => (
                  <>
                    <ListItemButton
                      key={index}
                      onClick={option.onClick}
                      sx={{
                        borderRadius: "1rem",
                        padding: "0.5rem 1rem",
                        margin: "0.5rem 0",
                        backgroundColor: colors.background.popover,
                        "&:hover": {
                          backgroundColor: colors.hover.muted,
                        },
                      }}
                      disabled={
                        option.disabled ? true : false
                      }
                    >
                      <ListItemText
                        primary={
                          <BodyLarge>
                            {option.title}
                          </BodyLarge>
                        }
                      />
                      <ListItemIcon
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        {option.endIcon()}
                      </ListItemIcon>
                    </ListItemButton>
                    {option.needDivider && <Divider />}
                  </>
                ))}
              </Box>
            </Box>
          </StyledPopoverContent>
        </ClickAwayListener>
      </StyledPopover>
    </>
  );
};

export const MinerOperationsTab = (props) => {
  const {
    downloadCSV,
    setTableKey,
    refetch,
    role,
    setLeftSidePanelOpen,
  } = props;
  const { colors } = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const { user, getAccessTokenSilently } = useAuth0();
  const {
    selectedSerials,
    customizationModalOpen,
    minerDeletionModalOpen,
    setMinerDeletionModalOpen,
    reImageModalOpen,
    setReImageModalOpen,
    resetCurtailSchedulesModalOpen,
    setResetCurtailSchedulesModalOpen,
    factoryResetModalOpen,
    setFactoryResetModalOpen,
    restartModalOpen,
    setRestartModalOpen,
    fluxVisionTuning,
    setFluxVisionTuning,
    ecoModalOpen,
    setEcoModalOpen,
    turboModalOpen,
    setTurboModalOpen,
    customPowerModalOpen,
    retuneModalOpen,
    transferModalOpen,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const isDisabled = !(
    siteSelectedName !== "" ||
    (siteSelectedName !== "" && groupSelectedName !== "")
  );

  const {
    data: limitsData,
    isFetched: isLimitsFetched,
    isFetching: isLimitsFetching,
  } = useQuery({
    queryKey: ["limitsData", siteSelectedName, anchorEl],
    queryFn: async () => {
      console.log("Fetching limits data");
      const authToken = await getAccessTokenSilently();
      return api.GetMaxLimits(authToken);
    },
    enabled: open,
  });

  console.log("limitsData", limitsData);

  const { maxths, maxpower } = limitsData || {};

  const navigate = useHistory();
  const handleClick = (event) => {
    event.stopPropagation();
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
    setFluxVisionTuning(true);
  };
  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Tooltip
          title={
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="row"
              sx={{ textAlign: "center" }}
            >
              <BodySmall sx={{ color: "white" }}>
                Click
                <span
                  className="material-symbols-outlined"
                  style={{
                    fontSize: "0.875rem",
                    verticalAlign: "middle",
                    color: "white",
                    margin: "0 0.2rem",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setLeftSidePanelOpen(true);
                  }}
                >
                  right_panel_close
                </span>{" "}
                icon to select group or site
              </BodySmall>
            </Box>
          }
          arrow
        >
          <span>
            <SecondaryButton colors={colors}
              ref={anchorRef}
              endIcon={
                <span className="material-symbols-outlined" >
                  assignment_add
                </span>
              }
              disabled={isDisabled || role === "user"}
              onClick={(event) => handleClick(event)}
            >
              Actions
            </SecondaryButton>
          </span>
        </Tooltip>
      </Box>

      <MoreOptionsCard
        open={open}
        handleClose={handleClose}
        anchorRef={anchorRef}
        downloadCSV={downloadCSV}
        setTableKey={setTableKey}
        refetch={refetch}
        role={role}
      />
      <MinerConfigurationDialog
        refetch={refetch}
        setTableKey={setTableKey}
      />
      {customizationModalOpen && (
        <CustomTHSForm
          maxths={maxths}
          maxpower={maxpower}
          refetch={refetch}
          setTableKey={setTableKey}
        />
      )}
      {customPowerModalOpen && (
        <CustomPowerForm
        maxpower={maxpower}
        refetch={refetch}
        setTableKey={setTableKey}
      />
      )}
      {retuneModalOpen && (
        <CustomRetuneForm
        refetch={refetch}
        setTableKey={setTableKey}
      />
      )}
      <EcoDialog
        open={ecoModalOpen}
        setOpen={setEcoModalOpen}
        refetch={refetch}
        setTableKey={setTableKey}
      />
      {/* {turboModalOpen && ( */}
        <TurboDialog
        open={turboModalOpen}
        setOpen={setTurboModalOpen}
        refetch={refetch}
        setTableKey={setTableKey}
        />
      {/* )} */}
      <RestartDialog
        open={restartModalOpen}
        setOpen={setRestartModalOpen}
        refetch={refetch}
        setTableKey={setTableKey}
      />
      {transferModalOpen && (
        <TransferMinerForm
        refetch={refetch}
        setTableKey={setTableKey}
        />
      )}
      <UpgradeMinersDialog
        refetch={refetch}
        setTableKey={setTableKey}
      />
      <DeleteMinersDialog
        open={minerDeletionModalOpen}
        setOpen={setMinerDeletionModalOpen}
        refetch={refetch}
      />
      {factoryResetModalOpen && (
        <FactoryResetDialog
        open={factoryResetModalOpen}
        setOpen={setFactoryResetModalOpen}
        refetch={refetch}
        setTableKey={setTableKey}
        />
      )}
      {resetCurtailSchedulesModalOpen && (
        <ResetCurtailSchedulesDialog
        open={resetCurtailSchedulesModalOpen}
        setOpen={setResetCurtailSchedulesModalOpen}
        refetch={refetch}
        setTableKey={setTableKey}
      />
      )}
      {reImageModalOpen && (
      <ReImageDialog
        open={reImageModalOpen}
        setOpen={setReImageModalOpen}
        refetch={refetch}
        setTableKey={setTableKey}
      />
      )}
    </React.Fragment>
  );
};
